// Full list of insurers and health TPAs accepted at Nehchal Eye Centre for
// cashless treatment (verified from the clinic's official insurer sheet).
export const INSURERS = [
  "Acko General Insurance",
  "Bajaj Allianz General Insurance",
  "Cholamandalam MS General Insurance",
  "Generali Central Insurance",
  "Go Digit General Insurance",
  "HDFC Ergo General Insurance",
  "ICICI Lombard General Insurance",
  "IFFCO Tokio General Insurance",
  "Kshema General Insurance",
  "Liberty General Insurance",
  "Magma General Insurance",
  "National Insurance",
  "NAVI General Insurance",
  "Raheja QBE General Insurance",
  "Reliance General Insurance",
  "Royal Sundaram General Insurance",
  "SBI General Insurance",
  "Shriram General Insurance",
  "Tata AIG General Insurance",
  "The New India Assurance",
  "The Oriental Insurance",
  "United India Insurance",
  "Universal Sompo General Insurance",
  "Zuno General Insurance",
  "Zurich Kotak General Insurance",
  "Aditya Birla Health Insurance",
  "Care Health Insurance",
  "Manipal Cigna Health Insurance",
  "Niva Bupa Health Insurance",
  "Star Health & Allied Insurance",
  "Narayana Health Insurance",
  "Galaxy Health Insurance",
  "Health TPA HITPA",
];
